import { instance, errorService } from '@/services/api'
import { masterAPIs, projectAPIs } from '@/services/authConstantsV1'
import { createRequest, tableName } from '@/services/config'
import {
  calculateGridHeight,
  showNotification,
  customComparator,
} from '@/services/calculate'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '../../GridRenderer/actionRendere'
import _ from 'lodash'
import CheckboxRender from '@/components/DynamicComponents/Renderers/checkboxRender'
import Pagination from '@/components/DynamicComponents/Pagination'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    type: String,
    columnSettings: Array,
    screenId: Number,
    isArchive: Boolean,
  },
  data: function() {
    const checkLength = (rule, value, callback) => {
      if (rule.field === 'unit') {
        if (String(value).length > 100) {
          callback(
            new Error('Unit must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      } else {
        if (String(value).length > 500) {
          callback(
            new Error(
              'Description must be less than or equals to 500 characters',
            ),
          )
        } else {
          callback()
        }
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'unit',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      unitList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        unit: undefined,
        description: undefined,
        isActive: 1,
      },
      rules: {
        unit: [
          { required: true, message: 'Please enter unit', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        description: [
          {
            required: true,
            message: 'Please enter description',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      loadUnits: false,
      selectedRowKeys: [],
      loadRefresh: false,
      // gridOptions: null,
      // columnDefs: null,
      defaultColDef: null,
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '410px',
      filters: {},
      updateRequest: null,
      requestKeys: ['unit', 'description', 'isActive'],
      //
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: [
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Unit',
          field: 'unit',
          width: 100,
          suppressSizeToFit: true,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Unit',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 370,
          filter: 'customFilter',
          headerTooltip: 'Description',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Unit',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteUnit', this.deleteUnit)
    this.$root.$on('editUnit', this.getUnitById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '6') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.unitList = []
        this.loading = true
        this.defaultSortedBy = 'unit'
        this.defaultSortOrder = true
        this.getUnits(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('editUnit')
    this.$root.$off('deleteUnit')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        checkboxCellRender: CheckboxRender,
        customFilter: CustomFilter,
        toolTipRenderer: ToolTipRenderer,
      }
    },

    // Refresh Units
    refreshUnits() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.unitList = []
      this.page = 0
      this.defaultSortedBy = 'unit'
      this.defaultSortOrder = true
      this.selectedRowKeys = []
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'unit',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getUnits(this.tableParams)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add new unit
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Unit'
      this.form.unit = undefined
      this.form.id = null
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save & Update unit
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (!this.form.id) {
            this.addUnit()
          } else {
            this.updateUnit()
          }
        }
      })
    },

    // Load Units
    getUnits(params, type) {
      instance
        .post(projectAPIs.master.unit.list(this.$route.params.id), {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          unit: _.get(this.filters, 'unit', undefined),
          description: _.get(this.filters, 'description', undefined),
        })
        .then(response => {
          this.unitList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'unitTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSetting()
          } else {
            this.getColumnSettings(params)
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get Unit By Id
    getUnitById(id, record) {
      this.visible = true
      this.modalTitle = 'Edit'
      this.spinner = true
      instance
        .get(projectAPIs.master.unit.details(this.$route.params.id, id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.unit = _.get(response.data, 'result.unit', null)
          this.form.description = _.get(
            response.data,
            'result.description',
            null,
          )
          this.form.isActive = _.get(response.data, 'result.isActive', 1)
          this.updateRequest = _.get(response.data, 'result', null)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Export Unit Excel Sheet
    exportUnits() {
      this.loadUnits = true
      instance
        .get(masterAPIs.exportUnit)
        .then(response => {
          this.loadUnits = false
        })
        .catch(error => {
          this.loadUnits = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const req = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(projectAPIs.master.unit.delete(this.$route.params.id), {
          data: req,
        })
        .then(response => {
          showNotification(
            'success',
            'Delete Unit',
            'Unit deleted successfully!',
          )
          this.refreshUnits()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All Property Sub Types
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected units ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected units
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(null)
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Delete Unit
    deleteUnit(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.unit}' ?`,
        content: h => (
          <div style="color:red;">
            <p>This action will delete all information related to this unit</p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.unitList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'unit'
        this.defaultSortOrder = true
      }
      this.getUnits(this.tableParams, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'unitTable',
        this.count > this.pageSize,
      )
      this.getColumnSettings()
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.unitList = []
      this.selectedRowKeys = []
      this.getUnits(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.unitList = []
      this.getUnits(this.gridOptions)
    },

    // Add unit
    addUnit() {
      this.spinner = true
      instance
        .post(projectAPIs.master.unit.add(this.$route.params.id), {
          Unit: this.form.unit,
          Description: this.form.description,
        })
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification('warning', 'Unit', response.data.message)
          } else {
            this.visible = false
            showNotification(
              'success',
              'Create Unit',
              'Unit created successfully!',
            )
            this.getUnits(this.tableParams)
            this.$refs.ruleForm.resetFields()
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Update unit
    updateUnit() {
      const req = createRequest(
        this.requestKeys,
        this.updateRequest,
        this.form,
      )

      if (!req.isValid) {
        showNotification('info', 'Update Unit', 'No changes found to update!')
        return
      }
      this.spinner = true
      instance
        .patch(
          projectAPIs.master.unit.details(this.$route.params.id, this.form.id),
          req.request,
        )
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification('warning', 'Unit', response.data.message)
          } else {
            this.visible = false
            showNotification(
              'success',
              'Update Unit',
              'Unit updated successfully!',
            )
            const newData = [...this.unitList]
            const index = newData.findIndex(i => i.id === this.form.id)
            newData[index]['unit'] = this.form.unit
            newData[index]['description'] = this.form.description
            this.unitList = newData
            this.$refs.ruleForm.resetFields()
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    getColumnSettings(params) {
      const columnDetails = this.columnSettings.find(
        i =>
          i.screenId === this.screenId &&
          i.tableName === tableName.project.master.unit,
      )
      if (columnDetails && columnDetails.columnDetails) {
        const tableState = JSON.parse(columnDetails.columnDetails)
        this.gridOptions.columnApi.applyColumnState({
          state: tableState,
          applyOrder: true,
        })
      } else {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
      params.columnApi.applyColumnState({
        state: [
          {
            colId: 'checkbox',
            hide: this.isArchive,
          },
          {
            colId: 'action',
            hide: this.isArchive,
          },
        ],
      })
      if (this.isArchive) {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: this.screenId,
        tableName: tableName.project.master.unit,
        columnDetails: JSON.stringify(tableState),
      }
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        this.updateColumnSetting()
      }
    },
  },
}
